import { BillingPeriodUnit } from '@commenda/types/src/billing/types';
import { Currency } from '@prisma/client';

export const formatCurrency = ({
  price,
  currency,
}: {
  price: number;
  currency: Currency;
}) => {
  return Intl.NumberFormat('en-US', {
    style: 'currency',
    currency,
  }).format(price / 100);
};

export const formatPrice = ({
  price,
  currency,
  period,
}: {
  price: number;
  currency: Currency;
  period?: {
    unit: BillingPeriodUnit;
    quantity: number;
  };
}) => {
  const priceInCurrency = formatCurrency({ price, currency });
  if (period?.unit) {
    const periodQuantityString =
      period?.quantity > 1 ? ` ${period.quantity}` : '';
    const periodPluralString = period?.quantity > 1 ? 's' : '';

    return `${priceInCurrency} /${periodQuantityString} ${period.unit}${periodPluralString}`;
  }
  return priceInCurrency;
};

export const supportedCurrencyOptions = [Currency.USD, Currency.INR].map(
  (currency) => ({
    label: currency,
    value: currency,
  })
);
